import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetServiceProPhotos} from '@/features/service-vetting/http/servicesVetting.http.ts'
import {ServiceProPhotos} from '@/features/service-vetting/types.ts'
import {remapServiceForVettingProPhotos} from '../utils'

export const useGetServiceProPhotos = (
    serviceId: number,
    options?: Omit<UseQueryOptions<ServiceProPhotos>, 'queryFn' & 'queryKey'>
) => {
    const query = useQuery({
        ...options,
        queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, serviceId],
        queryFn: () => httpGetServiceProPhotos({urlParams: {serviceId}, params: {responseType: 'extended'}})
    })

    return {...query, remappedData: query.data ? remapServiceForVettingProPhotos(query.data) : undefined}
}
